<template>
  <!-- 红包管理-累充红包条件 -->
  <div class="accumulated-topUp-conditions-box">
    <el-switch
      v-model="switchStatus"
      :active-value="1"
      :inactive-value="0"
      active-text="打开"
      inactive-text="关闭"
      @change="setSwitchStatus"
    >
    </el-switch>
    <p
      class="accumulated-line"
      style="line-height: 50px"
      v-for="(item, index) in dataList"
      :key="index"
    >
      <span style="margin: 0px 10px">{{ index + 1 }}级</span>
      <el-select
        v-model="item.type"
        placeholder="请选择类型"
        style="width: 150px; margin: 0px 10px"
      >
        <el-option label="充值金额" :value="1"></el-option>
        <el-option label="ROLL房选择" :value="2"></el-option>
        <el-option label="官方码单月充值" :value="3"></el-option>
      </el-select>
      <span style="margin: 0px 10px" v-if="item.type === 2">ROLL的id:</span>
      <el-input
        v-if="item.type === 2"
        v-model="item.roll_id"
        placeholder="请输入id"
        style="width: 100px"
      ></el-input>
      <span style="margin: 0px 10px" v-if="item.type != 2">金额:</span>
      <el-input
        v-if="item.type != 2"
        v-model="item.amount"
        placeholder="请输入金额"
        style="width: 120px"
      ></el-input>
      <span style="margin: 0px 10px">跳转的ROLL房id:</span>
      <el-input
        v-model="item.jump_roll_id"
        placeholder="请输入id"
        style="width: 100px"
      ></el-input>

      <span style="margin: 0px 10px">人数限制:</span>
      <el-input
        v-model="item.nums"
        placeholder="请输入人数"
        style="width: 100px"
      ></el-input>
      <span style="margin: 0px 10px">标题:</span>
      <el-input
        v-model="item.title"
        placeholder="请输入标题"
        style="width: 200px; margin: 0px 10px"
      ></el-input>
      <span style="margin: 0px 10px">上传图片:</span>
      <ImgUpload v-model="item.img"></ImgUpload>
      <el-button
        type="success"
        @click="handleExport(item.id)"
        style="margin: 0px 20px"
        >导出
      </el-button>
    </p>
    <el-button style="margin: 20px" type="primary" @click="submit()"
      >保存</el-button
    >
  </div>
</template>
<script>
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import ImgUpload from '@/components/common/ImgUpload.vue'
import saveFile from '@/utils/saveFile'

export default {
  components: {
    ImgUpload
  },
  data() {
    return {
      switchStatus: 0,//打开或关闭 0是关闭 1是打开
      dataList: [
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
        {
          type: 1,
          roll_id: '',
          jump_roll_id: '',
          amount: '',
          nums: '',
          title: '',
          img: ''
        },
      ]
    }
  },
  created() {
    this.getData()
    this.getSwitchStatus()//开关
  },
  methods: {
    getSwitchStatus(val) {
      //获取充值流水开关状态
      getApiData('welfare_level_enable')
        .then(res => {
          if (res && res.data) {
            this.switchStatus = 1
          } else {
            this.switchStatus = 0
          }
        })
    },
    setSwitchStatus(val) {
      //打开或关闭充值流水控制开关
      let params = {
        black: val
      }
      patchApiData('welfare_level_enable', params)
        .then(res => {
          this.$message.success("操作成功！")
        }).catch(err => {
          //修改失败还原按钮
          if (val === 1) {
            this.switchStatus = 0
          } else {
            this.switchStatus = 1
          }
        })
    },
    getData() {
      // 获取数据
      getApiData('welfare_config').then(res => {
        if (res) {
          if (res && res.length) {
            this.dataList = res
          }
        }
      }).finally(() => {
      })
    },
    submit() {
      let params = { data: this.dataList }
      patchApiData('welfare_config', params).then(res => {
        this.$message.success("保存成功！")
        this.getData()//刷新
      }).finally(() => {
      })
    },
    handleExport(id) {
      //导出
      http
        .get(
          api + `welfare_export/${id}`,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '累充条件满足用户.xlsx'
          })
        }).finally(() => {
        })
    },
  }

}
</script>
<style lang="less" scoped>
.accumulated-topUp-conditions-box {
  .accumulated-line {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
</style>